import { ImageIcon } from "lucide-react";

/**
 * Small, professional disclaimer used on pages that lean on stock photography.
 * Renders as a subtle line just above the page footer.
 */
export default function StockPhotoNotice() {
  return (
    <div
      data-testid="stock-photo-notice"
      className="border-t border-black/[0.06] bg-npbc-cream/60 py-6"
    >
      <div className="container-npbc">
        <div className="flex items-start gap-3 text-npbc-gray/70 text-[12px] leading-relaxed max-w-3xl mx-auto text-center">
          <ImageIcon className="hidden sm:block h-4 w-4 mt-0.5 flex-shrink-0 text-npbc-gray/50" />
          <p className="italic">
            <strong className="font-semibold text-npbc-gray/85 not-italic">Photo note:</strong>{" "}
            Some images on this page are professional stock photography used to reflect the spirit
            of our church family, ministries, and mission. As we capture more moments at
            New Philadelphia, they will replace these representative visuals.
          </p>
        </div>
      </div>
    </div>
  );
}
